import cssColors from 'tfs.css-variables'

export default {
  backButton: {
    color: cssColors.colorGrayA,
    textDecoration: 'none',
    fontWeight: 'bold',
  },
  backButtonLabel: {
    marginLeft: '0.4rem',
    verticalAlign: 'middle',
  },
}
